/**
 * What the address is called when the salon is not asked. The form's nickname
 * field is for people who keep several addresses; a salon saving its first one
 * has one, and a question it cannot yet answer is friction at the worst moment.
 */
export const DEFAULT_ADDRESS_NAME = "Salon";

/** The flags that make an address the one both checkouts use. */
export const MAKE_DEFAULT = {
  is_default_shipping: true,
  is_default_billing: true
} as const;
